import { Link } from "react-router-dom";
import Navbar from "../../components/navbar/navbarComponent";
import { useSelector } from "react-redux";
import { FileUploadIconAlt, VehiculosGridIcon, RegistrosIcon, LevantamientosIcon, CompactacionIcon } from "../../components/icons/SvgIcons";

function VehiculosComponent() {

  const tipoCurrentUser = useSelector((state) => state.tipoCurrentUser);

  return (
    <div>
      <Navbar />
      <div className="flex min-h-screen flex-col  items-center bg-[#F5FAFF] ">

        <div className="text-[#3d4245] text-[28px] font-bold font-inter sm:my-[3rem] my-[1rem]">
          Vehículos
        </div>

        <div className=" mb-[3rem] flex-col justify-start items-start gap-3 inline-flex mx-[1rem]">
          <Link to='/leerQR' className="self-stretch px-4 py-7 bg-white rounded-lg border border-[#c5dfff] justify-start items-center gap-2.5 inline-flex">
            <div className="w-[49px] h-[49px] relative" >
              <VehiculosGridIcon className="size-18 stroke-[#0477ad]" />
            </div>
            <div className="flex-col justify-start items-start gap-1 inline-flex">
              <div className="text-[#0477ad] text-lg font-bold font-inter">
                Leer QR
              </div>
              <div className="text-[#687073] text-sm font-normal font-inter">
                Lee los datos de un vehículo que ingresa o egresa del corralón.
              </div>
            </div>
            <div className="p-0.5 justify-start items-center gap-2.5 flex" />
          </Link>
          <Link to='/buscar' className="self-stretch px-4 py-7 bg-white rounded-lg border border-[#c5dfff] justify-start items-center gap-2.5 inline-flex">
            <div className="w-[49px] h-[49px] relative" >
              <FileUploadIconAlt className="size-18 stroke-[#0477ad]" />
            </div>
            <div className="flex-col justify-start items-start gap-1 inline-flex">
              <div className="text-[#0477ad] text-lg font-bold font-inter">
                Buscar vehículo
              </div>
              <div className="text-[#687073] text-sm font-normal font-inter">
                Busque vehículos por patente, numero de acta o de inventario.
              </div>
            </div>
          </Link>
          <Link to='/registros' className="self-stretch px-4 py-7 bg-white rounded-lg border border-[#c5dfff] justify-start items-center gap-2.5 inline-flex">
            <div className="w-[49px] h-[49px] relative" >
              <RegistrosIcon className="size-18 stroke-[#0477ad]" />
            </div>
            <div className="flex-col justify-start items-start gap-1 inline-flex">
              <div className="text-[#0477ad] text-lg font-bold font-inter">
                Tabla de registros
              </div>
              <div className="text-[#687073] text-sm font-normal font-inter">
                Movimientos dentro de la plataforma
              </div>
            </div>
          </Link>
          <Link to='/levantamientos' className="self-stretch px-4 py-7 bg-white rounded-lg border border-[#c5dfff] justify-start items-center gap-2.5 inline-flex">
            <div className="w-[49px] h-[49px] relative" >
              <LevantamientosIcon className="size-18 stroke-[#0477ad]" />
            </div>
            <div className="flex-col justify-start items-start gap-1 inline-flex">
              <div className="text-[#0477ad] text-lg font-bold font-inter">
                Levantamientos
              </div>
              <div className="text-[#687073] text-sm font-normal font-inter">
                Vehículos en corralón que pueden ser entregados
              </div>
            </div>
          </Link>
          {(tipoCurrentUser !== "viewer") &&
            <Link to='/compactacion' className="self-stretch px-4 py-7 bg-white rounded-lg border border-[#c5dfff] justify-start items-center gap-2.5 inline-flex">
              <div className="w-[49px] h-[49px] relative" >
                <CompactacionIcon className="size-18 stroke-[#0477ad]" />
              </div>
              <div className="flex-col justify-start items-start gap-1 inline-flex">
                <div className="text-[#0477ad] text-lg font-bold font-inter">
                  Compactar vehículo
                </div>
                <div className="text-[#687073] text-sm font-normal font-inter">
                  Lista de vehículos a compactar
                </div>
              </div>
            </Link>
          }
        </div>

      </div>
    </div>
  );
}

export default VehiculosComponent;

